<script>
    import { getUrl } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/whatsapp/whatsapp_url.js?1733898724704';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724704';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    export let product = null; // Product
    export let list = []; // Product[]

    let url = '';

    $: url = build_url(product, list);

    function build_url(product, list) {
        // combine the products together
        const names = [];
        const p_name = get_attribute_value(product, 'name');
        if (p_name) {
            names.push(p_name);
        }
        names.push(
            ...(Array.isArray(list)
                ? list.map((p) => get_attribute_value(p, 'name'))
                : [])
        );
        return getUrl(names);
    }
</script>

{#if url}
    <div class="c-whatsapp-button">
        <a href={url} target="_blank" class="c-whatsapp-button__link">
            <i class="ri-whatsapp-line" />
            <span class="c-whatsapp-button__intro">Noch Fragen?</span>
            <span>Schreiben Sie uns!</span>
        </a>
    </div>
{/if}


<style>
    
    a {
        width: 100%;
        gap: 0 0.5rem;
    }

    @media (min-width: 768px) {
        .c-whatsapp-button__link {
            font-size: 1rem !important;
            padding: 15px 20px !important;
        }
    }
</style>